import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import { getYearFromVin } from '../utils/vinDecoder';
import { MalsoPreview, ContractPreview, NonBizPreview, PumuiPreview } from './DocumentPreviews';
import CarRegisterOCR from './CarRegisterOCR';
import CarRegisterManual from './CarRegisterManual';
import CarRegisterBulk from './CarRegisterBulk';
import CustomModal from './CustomModal';
import { isLawEnforced } from '../utils/lawEnforcement';
import carPrintFlow from '../utils/carPrintFlow';
import { getEngCarName } from '../utils/carNames';

import CarRegisterForm from './CarRegisterForm';

function CarRegisterPage({showToast,user}){
  // ═══ 모드: ocr / manual / batch-img / batch-csv ═══
  var[regRestored,setRegRestored]=useState(false);
  var[mode,setMode]=useState('ocr');
  var [modal,setModal]=useState(null);
  var closeModal=function(){setModal(null)};

  // ═══ 공통 state ═══
  var[carNo,setCN]=useState('');var[vin,setVin]=useState('');var[carType,setCT]=useState('');
  var[usage2,setU2]=useState('자가용');var[owner,setOW]=useState('');var[ownerAddr,setOA]=useState('');
  var[ownerId,setOI]=useState('');var[ownerIdBack,setOIB]=useState('');var[regDate,setRD]=useState('');
  var[mileage,setML]=useState(0);var[ownerPayment,setOwnerPayment]=useState('');var[dealerPayment,setDealerPayment]=useState('');var[contractPrice,setCP]=useState('');
  var[balance,setBL]=useState('');var[buyAddress,setBA]=useState('');var[buyRegion,setBuyRegion]=useState('');var[invoiceInputValue,setInvoiceInputValue]=useState('');
  var[sellCurrency,setSellCurrency]=useState('KRW');var[sellExchangeRate,setSellExchangeRate]=useState('');
  var[invoiceMarkupWon,setInvoiceMarkupWon]=useState(100000);var[invoiceManuallyEdited,setInvoiceManuallyEdited]=useState(false);
  var[ocrFuel,setOcrFuel]=useState('');var[ocrDisp,setOcrDisp]=useState('');var[ocrColor,setOcrColor]=useState('');
  var[purchaseType,setPurchaseType]=useState('individual');
  var[scrapPurchase,setScrapPurchase]=useState(false); // 폐차장 매입 — 의제매입세액공제 제외
  var[vatAmountMan,setVatAmountMan]=useState('');
  var[supplyAmountMan,setSupplyAmountMan]=useState('');
  var[vatSeparate,setVatSeparate]=useState(false);
  var[purchaseDate,setPurchaseDate]=useState(new Date().toISOString().slice(0,10));
  var[taxInvoiceFile,setTaxInvoiceFile]=useState(null);
  var[companies,setCompanies]=useState([]);var[selCompany,setSelCompany]=useState(null);
  var[myCompanies,setMyCompanies]=useState([]);
  var canSelectCompany=user&&(user.role==='doc_agency'||user.role==='관리자'||user.role==='admin');
  var[compSearch1,setCompSearch1]=useState('');var[compDd1,setCompDd1]=useState(false);
  var[compSearch2,setCompSearch2]=useState('');var[compDd2,setCompDd2]=useState(false);
  var[pDoc,setPD]=useState('malso');var[saving,setSV]=useState(false);
  var[printing,setPrinting]=useState(false);
  var[regDoneModal,setRegDoneModal]=useState(null);
  var[initStatus,setInitStatus]=useState('등록완료');
  var[cancelCompletedAt,setCancelCompletedAt]=useState('');
  var[cancelRequestedAt,setCancelRequestedAt]=useState('');
  var[autoOwnerSeal,setAutoOwnerSeal]=useState(true);
  // Phase B Wave 2.3: 소유자 매도 광고 동의 (자동차관리법 제57조의2 제3항 — 2026-06-03 시행)
  var[ownerConsentGiven,setOwnerConsentGiven]=useState(false);
  var[ownerConsentDate,setOwnerConsentDate]=useState(new Date().toISOString().slice(0,10));
  var[ownerConsentMethod,setOwnerConsentMethod]=useState('self_owner');
  var[ownerConsentFile,setOwnerConsentFile]=useState(null);
  var[ocrDone,setOD]=useState(false);var[ocrLoading,setOL]=useState(false);
  var[ocrConfidence,setOcrConfidence]=useState({});
  // #233 — 차종 자동교정 시 OCR 원본. 무엇이 무엇으로 바뀌었는지 사용자에게 보여준다.
  var[ocrCarTypeOrig,setOcrCarTypeOrig]=useState('');
  var[vinYear,setVinYear]=useState(null);
  var[vinYearMismatch,setVinYearMismatch]=useState(false);
  var[vinSearchResults,setVinSearchResults]=useState([]);
  var[vinSearchShow,setVinSearchShow]=useState(false);
  var[vinSearchTimer,setVinSearchTimer]=useState(null);
  var[vinDup,setVinDup]=useState(null);
  var[files,setFiles]=useState([]);var[dragOver,setDO]=useState(false);
  var[imgZoom,setImgZoom]=useState(1);var[imgPos,setImgPos]=useState({x:0,y:0});var[imgDrag,setImgDrag]=useState(null);
  var zoomImg=function(src){
    return(<div style={{width:'100%',height:'100%',display:'flex',flexDirection:'column'}}>
      <div style={{flex:1,overflow:'hidden',cursor:imgDrag?'grabbing':imgZoom>1?'grab':'zoom-in',position:'relative'}}
        onWheel={function(e){e.preventDefault();var nz=Math.max(1,Math.min(5,imgZoom+(e.deltaY<0?0.3:-0.3)));setImgZoom(nz);if(nz<=1)setImgPos({x:0,y:0})}}
        onDoubleClick={function(){if(imgZoom<2){setImgZoom(2)}else{setImgZoom(1);setImgPos({x:0,y:0})}}}
        onClick={function(e){if(e.ctrlKey){setImgZoom(1);setImgPos({x:0,y:0})}}}
        onMouseDown={function(e){if(imgZoom>1){e.preventDefault();setImgDrag({startX:e.clientX,startY:e.clientY,origX:imgPos.x,origY:imgPos.y})}}}
        onMouseMove={function(e){if(imgDrag){var dx=e.clientX-imgDrag.startX;var dy=e.clientY-imgDrag.startY;setImgPos({x:imgDrag.origX+dx,y:imgDrag.origY+dy})}}}
        onMouseUp={function(){setImgDrag(null)}}
        onMouseLeave={function(){setImgDrag(null)}}>
        <img src={src} alt="원본" style={{width:'100%',height:'100%',objectFit:'contain',transform:'translate('+imgPos.x+'px,'+imgPos.y+'px) scale('+imgZoom+')',transformOrigin:'center center',transition:imgDrag?'none':'transform 0.15s',userSelect:'none',pointerEvents:'none'}} draggable={false}/>
        {imgZoom>1&&<div style={{position:'absolute',bottom:6,right:6,background:'rgba(0,0,0,0.6)',color:'#fff',padding:'2px 8px',borderRadius:4,fontSize:11}}>{Math.round(imgZoom*100)}%</div>}
      </div>
      <div style={{textAlign:'center',fontSize:11,color:'#94a3b8',padding:'4px 0',flexShrink:0}}>휠: 확대/축소 · 드래그: 이동 · Ctrl+클릭: 원래 크기</div>
    </div>);
  };

  // ═══ 일괄 이미지 state ═══
  var[batchImages,setBatchImages]=useState([]);
  var[batchIdx,setBatchIdx]=useState(0);
  var[batchStatus,setBatchStatus]=useState([]); // 'pending'|'done'|'skip'
  var[batchOcrLoading,setBatchOcrLoading]=useState(false);
  var[batchOcrResults,setBatchOcrResults]=useState([]); // OCR 결과 캐시 배열
  var[batchOcrDoneCount,setBatchOcrDoneCount]=useState(0); // OCR 완료 수

  // ═══ CSV state ═══
  var[batchFile,setBatchFile]=useState(null);var[batchLog,setBatchLog]=useState([]);var[batchInProgress,setBatchInProgress]=useState(false);
  // ═══ 엑셀 AI 매칭 state ═══
  var[xlStep,setXlStep]=useState('upload'); // upload/mapping/preview/done
  var[xlAnalysis,setXlAnalysis]=useState(null);
  var[xlMapping,setXlMapping]=useState({});
  var[xlLoading,setXlLoading]=useState(false);
  var[xlResults,setXlResults]=useState([]);
  var[xlProgress,setXlProgress]=useState('');
  var[xlDetailOpen,setXlDetailOpen]=useState({});

  useEffect(function(){
    authFetch(API+'/settings/companies').then(function(r){return r.json()}).then(function(d){
      setCompanies(d||[]);
      if(!canSelectCompany&&d&&d.length>0){var uc=d.find(function(c){return c.id===(user.activeCompanyId||user.companyId)});if(uc)setSelCompany(uc);else setSelCompany(d[0])}
    }).catch(function(){});
    if(canSelectCompany){authFetch(API+'/auth/my-companies').then(function(r){return r.json()}).then(function(d){if(d.success){setMyCompanies(d.companies||[]);var active=d.companies.find(function(c){return c.id===d.activeCompanyId});if(active)setSelCompany(active);else if(d.companies.length>0)setSelCompany(d.companies[0])}}).catch(function(){})}
  },[]);

  // 인보이스 자동완성 마진 로드 (선택 업체 변경 시 갱신)
  useEffect(function(){
    var cid=selCompany?selCompany.id:0;
    if(!cid)return;
    authFetch(API+'/settings/invoice-markup?companyId='+cid).then(function(r){return r.json()}).then(function(d){
      if(d&&typeof d.invoice_markup==='number')setInvoiceMarkupWon(d.invoice_markup);
    }).catch(function(){});
  },[selCompany]);

  // 현재 USD/KRW 환율 자동 조회 (마운트 시 1회, 사용자 미입력 시에만)
  useEffect(function(){
    if(sellExchangeRate)return;
    authFetch(API+'/settings/exchange-rate').then(function(r){return r.json()}).then(function(d){
      if(d&&d.rate&&!sellExchangeRate)setSellExchangeRate(String(d.rate));
    }).catch(function(){});
  },[]);

  // 명의자 송금액 변경 시 인보이스 금액 자동완성 (KRW 모드 + 사용자 미수정 시에만)
  // 양방향 동기화: 명의자 비우면 인보이스도 비움
  useEffect(function(){
    if(invoiceManuallyEdited)return;
    if(sellCurrency!=='KRW')return;
    var ownerWon=(parseInt(String(ownerPayment).replace(/[^0-9]/g,''))||0)*10000;
    if(ownerWon<=0){setInvoiceInputValue('');return;}
    var suggestedWon=ownerWon+(invoiceMarkupWon||0);
    setInvoiceInputValue(String(suggestedWon));
  },[ownerPayment,invoiceMarkupWon,sellCurrency,invoiceManuallyEdited]);

  var now=new Date();var yyyy=now.getFullYear();var mm=now.getMonth()+1;var dd=now.getDate();
  var ls={display:'block',fontSize:11,fontWeight:600,color:'#64748b',marginBottom:4,marginTop:10};
  var is={width:'100%',padding:'8px 10px',border:'1px solid #d0d5dd',borderRadius:8,fontSize:13,outline:'none',background:'#fff'};
  var isLow=function(field){return ocrConfidence[field]==='low'?{background:'#fefce8',border:'1px solid #fbbf24'}:{}};
  var searchVin=function(q){
    if(vinSearchTimer)clearTimeout(vinSearchTimer);
    if(!q||q.length<3){setVinSearchResults([]);setVinSearchShow(false);return;}
    var t=setTimeout(function(){
      authFetch(API+'/cars/search-vin?q='+encodeURIComponent(q)).then(function(r){return r.json()}).then(function(d){setVinSearchResults(d);setVinSearchShow(d.length>0)}).catch(function(){});
    },300);
    setVinSearchTimer(t);
  };
  var checkVinDup=function(v){
    if(!v||v.length<5){setVinDup(null);return;}
    authFetch(API+'/cars/check-vin?vin='+encodeURIComponent(v)).then(function(r){return r.json()}).then(function(d){setVinDup(d.exists?d.car:null)}).catch(function(){setVinDup(null)});
  };
  // #233 — 차종은 사전 자동교정이 일어날 수 있어, 무엇이 무엇으로 바뀌었는지 명시한다.
  // (교정 사실을 숨기면 사용자가 등록증과 다른 차종을 그대로 저장하게 된다.)
  var lowBadge=function(field){
    if(ocrConfidence[field]!=='low')return null;
    var txt=(field==='carType'&&ocrCarTypeOrig)?('원본 '+ocrCarTypeOrig+' → 자동수정, 확인 필요'):'확인 필요';
    return <span style={{fontSize:9,color:'#b45309',background:'#fef3c7',padding:'1px 6px',borderRadius:4,marginLeft:4}}>{txt}</span>;
  };

  // ═══ OCR 결과를 폼에 적용 ═══
  var applyOcrResult=function(d){
    if(!d)return;
    // 이전 차량 입력분 초기화 (다른 차량 OCR 시 금액 잔류 방지)
    setOwnerPayment('');setDealerPayment('');setCP('');setBL('');
    setInvoiceInputValue('');setInvoiceManuallyEdited(false);
    setVatAmountMan('');setSupplyAmountMan('');
    setCN(d.carNo||'');setVin(d.vin||'');setCT(d.carType||'');setU2(d.usage2||'자가용');checkVinDup(d.vin||'');
    setOW(d.owner||'');setOA(d.ownerAddr||'');
    var fi=(d.ownerId||'').split('-');setOI(fi[0]||'');setOIB(fi[1]&&fi[1].indexOf('*')<0&&fi[1].length>=7?'*******':fi[1]||'');
    setRD(d.regDate||'');setML(parseInt(String(d.mileage).replace(/[^0-9]/g,''))||0);
    setOcrFuel(d.fuel||'');setOcrDisp(d.displacement||'');
    setOcrConfidence(d.confidence||{});setOcrCarTypeOrig(d.carTypeOriginal||'');setOD(true);
    if(d.regDateCandidates&&d.regDateCandidates.length>1){setOcrConfidence(function(prev){return Object.assign({},prev,{regDate:'low'})})}
    if(d.autoStatus==='말소완료'){setInitStatus('말소완료');setCancelCompletedAt(d.cancelDate||'')}
    var ocrYear=d.regDate?parseInt(d.regDate.slice(0,4)):null;
    var vy=getYearFromVin(d.vin||'',ocrYear);setVinYear(vy);
    setVinYearMismatch(vy&&ocrYear&&Math.abs(vy-ocrYear)>=2);
    // sessionStorage에 임시 저장 (30분 유효, 회사별 독립 키)
    // 키 분리 이유: 단일 키 방식은 다른 회사로 전환 시 기존 드래프트가 삭제되어 복귀 후 복원 불가.
    // 회사별 키로 분리하면 여러 회사의 드래프트가 동시에 보존됨.
    var _curCid=(user&&(user.activeCompanyId||user.companyId))||0;
    try{sessionStorage.setItem('autodoc_ocr_temp_'+_curCid,JSON.stringify({data:d,timestamp:Date.now()}))}catch(e){}
  };
  // 마운트시 sessionStorage 복원 (회사별 키)
  useEffect(function(){
    var curCid=(user&&(user.activeCompanyId||user.companyId))||0;
    try{
      // 레거시 단일 키 정리 (이전 버전 잔존 데이터)
      sessionStorage.removeItem('autodoc_ocr_temp');
      var saved=sessionStorage.getItem('autodoc_ocr_temp_'+curCid);
      if(saved){
        var parsed=JSON.parse(saved);
        var freshEnough=parsed.timestamp&&Date.now()-parsed.timestamp<1800000;
        if(freshEnough&&parsed.data){
          applyOcrResult(parsed.data);
        }else{sessionStorage.removeItem('autodoc_ocr_temp_'+curCid)}
      }
    }catch(e){}
    // 수기 입력 금액 필드는 차량별로 다르므로 sessionStorage 복원하지 않음
    try{sessionStorage.removeItem('autodoc_carreg_temp')}catch(e){}
    setRegRestored(true);
  },[]);

  // ═══ OCR 함수 (단건 - 폼에 적용) ═══
  var doOcr=function(file){
    setOL(true);
    var fd=new FormData();fd.append('image',file);
    return authFetch(API+'/ocr',{method:'POST',body:fd}).then(function(r){return r.json()}).then(function(data){
      setOL(false);
      if(data.success){applyOcrResult(data.data);return data.data;}
      else{showToast('OCR 실패: '+(data.error||''),'err');return null;}
    }).catch(function(){setOL(false);showToast('서버오류','err');return null;});
  };

  // ═══ OCR Raw (결과만 반환, 폼 안 건드림) ═══
  var doOcrRaw=function(file){
    var fd=new FormData();fd.append('image',file);
    return authFetch(API+'/ocr',{method:'POST',body:fd}).then(function(r){return r.json()}).then(function(data){
      if(data.success)return data.data;
      return null;
    }).catch(function(){return null;});
  };

  // ═══ 등록 함수 ═══
  // opts.skipModal: regDoneModal 생략하고 콜백으로 carId 전달 (printDoc 경로용)
  // opts._waitPrintType: 'malso'|'contract'|'nonbiz'|'pumui' — 서버가 해당 type PDF 를
  //   우선 await 생성한 뒤 응답. 응답에 docsReady:[type] 포함. 콜백 2번째 인자로 응답 전달.
  var reg=function(callback,opts){
    opts=opts||{};var skipModal=!!opts.skipModal;var _waitPrintType=opts._waitPrintType||null;
    if(!vin){showToast('차대번호 필수','err');return}
    if(vinDup){showToast('이미 등록된 차대번호입니다 ('+vinDup.carNo+' '+getEngCarName(vinDup.carType||'')+')','err');return}
    // Phase B Wave 2.3: 시행일 이후 동의 필수 (백엔드 400 응답 대응 전 UX 가드)
    if(isLawEnforced() && !ownerConsentGiven){
      showToast('자동차관리법에 따라 소유자 매도 광고 동의 체크 + 동의서 PDF 업로드가 필요합니다','err');return;
    }
    if(isLawEnforced() && ownerConsentGiven && !ownerConsentFile){
      showToast('시행일 이후에는 동의서 PDF 업로드가 필수입니다','err');return;
    }
    if(saving)return;setSV(true);
    authFetch(API+'/cars',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
      carNo:carNo,vin:vin,carType:carType,usage2:usage2,owner:owner,ownerAddr:ownerAddr,
      ownerId:ownerId+'-'+ownerIdBack,regDate:regDate,
      mileage:parseInt(String(mileage).replace(/[^0-9]/g,''))||0,
      owner_payment:(parseInt(String(ownerPayment).replace(/[^0-9]/g,''))||0)*10000,
      dealer_payment:(parseInt(String(dealerPayment).replace(/[^0-9]/g,''))||0)*10000,
      sellPrice:0,
      invoice_amount:sellCurrency==='KRW'?(parseInt(String(invoiceInputValue).replace(/[^0-9]/g,''))||0):0,
      sell_price_usd:sellCurrency==='USD'?(parseFloat(String(invoiceInputValue).replace(/[^0-9.]/g,''))||0):0,
      sell_exchange_rate:sellCurrency==='USD'?(parseFloat(sellExchangeRate)||0):0,
      exporter:selCompany?selCompany.name:'',country:'',
      buyerId:0,buyAddress:buyAddress,buyRegion:buyRegion,buyDate:'',buySource:'',
      companyId:selCompany?selCompany.id:(user?user.companyId||0:0),purchaseType:purchaseType,vatAmount:Math.round((parseFloat(vatAmountMan)||0)*10000),supplyAmount:Math.round((parseFloat(supplyAmountMan)||0)*10000),
      purchaseDate:purchaseDate,fuel:ocrFuel,displacement:ocrDisp,color:ocrColor,
      scrap_purchase:scrapPurchase?1:0,
      status:initStatus,
      cancel_requested_at:cancelRequestedAt||'',
      cancel_completed_at:cancelCompletedAt||'',
      auto_owner_seal:autoOwnerSeal?1:0,
      // Phase B Wave 2.3: 소유자 매도 광고 동의
      ownerConsentGiven:ownerConsentGiven,
      ownerConsentDate:ownerConsentGiven?ownerConsentDate:null,
      ownerConsentMethod:ownerConsentGiven?ownerConsentMethod:null,
      // "등록하고 출력" 경로 — 서버가 선택 탭 PDF 를 우선 생성 후 응답
      __waitPrintType:_waitPrintType
    })}).then(function(r){return r.json()}).then(function(d){
      setSV(false);
      if(d.success){
        // 저장 성공 즉시 sessionStorage + 상태 정리 (모달 닫기 전 - 사이드바 이동 등 우회 방어)
        var _doneCid=(user&&(user.activeCompanyId||user.companyId))||0;
        try{sessionStorage.removeItem('autodoc_carreg_temp');sessionStorage.removeItem('autodoc_ocr_temp_'+_doneCid);sessionStorage.removeItem('autodoc_ocr_temp')}catch(e){}
        setOwnerPayment('');setDealerPayment('');setInvoiceInputValue('');setInvoiceManuallyEdited(false);setVatAmountMan('');setSupplyAmountMan('');
        if((purchaseType==='business'||purchaseType==='individual_biz_tax')&&taxInvoiceFile&&d.id){
          var fd2=new FormData();fd2.append('file',taxInvoiceFile);fd2.append('docType','tax_invoice');
          authFetch(API+'/cars/'+d.id+'/upload-doc',{method:'POST',body:fd2}).catch(function(){});
        }
        // Phase B Wave 2.3: 동의서 PDF 업로드 (동의 체크 + 파일 선택 시)
        if(ownerConsentGiven&&ownerConsentFile&&d.id){
          var fdC=new FormData();fdC.append('file',ownerConsentFile);fdC.append('docType','owner_consent');
          authFetch(API+'/cars/'+d.id+'/upload-doc',{method:'POST',body:fdC}).catch(function(){});
        }
        if(initStatus==='말소완료'&&d.id){
          var malsoFile=files.length>0?files[0]:(batchImages&&batchImages[batchIdx]?batchImages[batchIdx]:null);
          if(malsoFile){var fd3=new FormData();fd3.append('file',malsoFile);fd3.append('docType','malsoCert');authFetch(API+'/cars/'+d.id+'/upload-doc',{method:'POST',body:fd3}).catch(function(){});}
        }
        // 자동차등록증 원본 이미지 저장 (바이어 요청 대비) - 말소완료 시작 시에는 업로드 파일이 말소증이므로 스킵
        if(initStatus!=='말소완료'){
          var regFile=files.length>0?files[0]:(batchImages&&batchImages[batchIdx]?batchImages[batchIdx]:null);
          if(regFile&&d.id){var fd4=new FormData();fd4.append('file',regFile);fd4.append('docType','registration');authFetch(API+'/cars/'+d.id+'/upload-doc',{method:'POST',body:fd4}).catch(function(){});}
        }
        var buyPriceVal=((parseInt(String(ownerPayment).replace(/[^0-9]/g,''))||0)+(parseInt(String(dealerPayment).replace(/[^0-9]/g,''))||0));
        if(skipModal){if(callback)callback(d.id,d);}
        else setRegDoneModal({carNo:carNo,carType:getEngCarName(carType||''),buyPrice:buyPriceVal,carId:d.id,onClose:function(){setRegDoneModal(null);if(callback)callback(d.id,d);else rst();}});
      }else{showToast('실패: '+(d.error||''),'err');if(skipModal&&callback)callback(null);}
    }).catch(function(){setSV(false);showToast('서버오류','err')});
  };

  var rst=function(){var _rstCid=(user&&(user.activeCompanyId||user.companyId))||0;setCN('');setVin('');setCT('');setU2('자가용');setOW('');setOA('');setOI('');setOIB('');setRD('');setML(0);setOwnerPayment('');setDealerPayment('');setCP('');setBL('');setBA('');setSelCompany(null);setOcrFuel('');setOcrDisp('');setOD(false);setOcrConfidence({});setOcrCarTypeOrig('');setFiles([]);setTaxInvoiceFile(null);setPurchaseType('individual');setScrapPurchase(false);setVinYear(null);setVinYearMismatch(false);setVinDup(null);setInitStatus('등록완료');setCancelCompletedAt('');setCancelRequestedAt('');setOwnerConsentGiven(false);setOwnerConsentMethod('self_owner');setOwnerConsentFile(null);try{sessionStorage.removeItem('autodoc_ocr_temp_'+_rstCid);sessionStorage.removeItem('autodoc_ocr_temp');sessionStorage.removeItem('autodoc_carreg_temp')}catch(e){}};

  // ═══ 출력 버튼 — 차량등록 실행 + 선택 탭 PDF 우선 완성 + 바로 열기 ═══
  // 플로우 상세: utils/carPrintFlow.js (리팩터 2026-04-21, 코드리뷰 Step A).
  //   기존 CarRegister.printDoc 50줄을 carPrintFlow.run 으로 이관.
  //   부수 fix: failPopup Cancel 시 rst() 미호출 (폼 유지).
  var printDoc=function(){
    carPrintFlow.run({
      API:API,authFetch:authFetch,reg:reg,rst:rst,
      showToast:showToast,setPrinting:setPrinting,
      printing:printing,saving:saving,pDoc:pDoc,carNo:carNo
    });
  };

  // ═══ 일괄 이미지 함수 ═══
  // 5장씩 병렬 OCR
  var runBatchOcr=function(images){
    var doneCount=0;
    setBatchOcrDoneCount(0);
    // 전체 동시 시작 - 모든 이미지를 한꺼번에 OCR 요청
    var promises=images.map(function(img,idx){
      return doOcrRaw(img).then(function(r){
        doneCount++;
        setBatchOcrDoneCount(doneCount);
        setBatchOcrResults(function(prev){var n=prev.slice();n[idx]=r;return n});
        return r;
      });
    });
    return Promise.all(promises);
  };

  var onBatchImgSelect=function(fl){
    var arr=Array.from(fl).filter(function(f){return f.type.startsWith('image/')});
    if(!arr.length){showToast('이미지 파일을 선택하세요','err');return;}
    setBatchImages(arr);setBatchIdx(0);
    setBatchStatus(arr.map(function(){return 'pending'}));
    setBatchOcrResults(new Array(arr.length).fill(null));
    setBatchOcrLoading(true);rst();
    // 전체 OCR 동시 시작
    runBatchOcr(arr).then(function(){
      setBatchOcrLoading(false);
      showToast('✅ 전체 OCR 완료 ('+arr.length+'장)');
    });
  };

  // 현재 인덱스의 캐시된 결과를 폼에 적용
  var applyBatchResult=function(idx){
    var r=batchOcrResults[idx];
    rst();
    if(r){applyOcrResult(r);}else{setOD(false);}
  };

  // OCR 결과 도착하면 현재 인덱스 자동 적용
  useEffect(function(){
    if(mode!=='batch-img')return;
    if(batchOcrResults.length===0)return;
    var r=batchOcrResults[batchIdx];
    if(r&&!ocrDone){applyOcrResult(r);}
  },[batchOcrResults,batchIdx,mode]);

  var batchNext=function(newStatus){
    var ns=batchStatus.slice();ns[batchIdx]=newStatus;setBatchStatus(ns);
    var nextIdx=-1;
    for(var i=batchIdx+1;i<batchImages.length;i++){if(ns[i]==='pending'){nextIdx=i;break;}}
    if(nextIdx===-1){
      // 모든 처리 완료 확인
      var allDone=ns.every(function(s){return s==='done'||s==='skip'});
      if(allDone){showToast('🎉 모든 차량 처리 완료!');setTimeout(function(){setBatchImages([]);setBatchStatus([]);setBatchOcrResults([]);setBatchIdx(0);setBatchOcrDoneCount(0);rst()},1500)}
      return;
    }
    setBatchIdx(nextIdx);applyBatchResult(nextIdx);
  };
  var batchRegAndNext=function(){reg(function(){batchNext('done')})};
  var batchSkip=function(){batchNext('skip')};
  var batchGoTo=function(i){
    if(batchStatus[i]==='done')return;
    setBatchIdx(i);applyBatchResult(i);
  };
  var batchDoneCount=batchStatus.filter(function(s){return s==='done'}).length;

  // ═══ CSV 함수 ═══
  var parseBatchCsv=function(text){
    var lines=text.split(/\r?\n/).map(function(l){return l.trim()}).filter(function(l){return l.length>0});
    if(lines.length<2)return[];var headers=lines[0].split(',').map(function(h){return h.trim()});
    return lines.slice(1).map(function(line){var fields=line.split(',').map(function(f){return f.trim()});var item={};headers.forEach(function(h,i){item[h]=fields[i]||''});return item}).filter(function(item){return item.carNo||item.vin});
  };
  var batchRegisterCsv=function(){
    if(!batchFile){showToast('CSV 파일을 선택하세요','err');return;}
    var reader=new FileReader();
    reader.onload=function(e){
      var rows=parseBatchCsv(e.target.result);if(!rows.length){showToast('CSV에 등록할 차량이 없습니다','err');return;}
      setBatchInProgress(true);setBatchLog([]);
      authFetch(API+'/cars/bulk',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({rows:rows})}).then(function(r){return r.json()}).then(function(d){
        setBatchInProgress(false);if(d.success){setBatchLog(d.results||[]);setRegDoneModal({carNo:'일괄 등록',carType:d.successCount+'대 성공 / '+d.failCount+'대 실패',buyPrice:0,carId:null,onClose:function(){setRegDoneModal(null);}});}else showToast('실패: '+(d.error||''),'err');
      }).catch(function(){setBatchInProgress(false);showToast('서버 오류','err');});
    };reader.readAsText(batchFile,'UTF-8');
  };

  // ═══ 입력 폼 — CarRegisterForm.js로 분리 ═══
  var formShowAlways = mode==='manual' || ocrDone || (mode==='batch-img'&&ocrDone);
  var renderForm = function() {
    var f = {
      vinYearMismatch:vinYearMismatch,regDate:regDate,vinYear:vinYear,
      canSelectCompany:canSelectCompany,myCompanies:myCompanies,
      compDd1:compDd1,setCompDd1:setCompDd1,compSearch1:compSearch1,setCompSearch1:setCompSearch1,
      selCompany:selCompany,setSelCompany:setSelCompany,
      ls:ls,is:is,lowBadge:lowBadge,isLow:isLow,
      carNo:carNo,setCN:setCN,vin:vin,setVin:setVin,
      setVinYear:setVinYear,setVinYearMismatch:setVinYearMismatch,
      searchVin:searchVin,checkVinDup:checkVinDup,
      vinSearchResults:vinSearchResults,setVinSearchShow:setVinSearchShow,
      vinSearchShow:vinSearchShow,vinDup:vinDup,
      setModal:setModal,closeModal:closeModal,
      carType:carType,setCT:setCT,usage2:usage2,setU2:setU2,setRD:setRD,
      mileage:mileage,setML:setML,ocrFuel:ocrFuel,setOcrFuel:setOcrFuel,
      ocrDisp:ocrDisp,setOcrDisp:setOcrDisp,
      ocrColor:ocrColor,setOcrColor:setOcrColor,
      owner:owner,setOW:setOW,ownerId:ownerId,setOI:setOI,
      ownerIdBack:ownerIdBack,setOIB:setOIB,ownerAddr:ownerAddr,setOA:setOA,
      compDd2:compDd2,compSearch2:compSearch2,setCompDd2:setCompDd2,setCompSearch2:setCompSearch2,
      companies:companies,
      purchaseType:purchaseType,setPurchaseType:setPurchaseType,
      scrapPurchase:scrapPurchase,setScrapPurchase:setScrapPurchase,
      vatAmountMan:vatAmountMan,setVatAmountMan:setVatAmountMan,
      supplyAmountMan:supplyAmountMan,setSupplyAmountMan:setSupplyAmountMan,
      vatSeparate:vatSeparate,setVatSeparate:setVatSeparate,
      taxInvoiceFile:taxInvoiceFile,setTaxInvoiceFile:setTaxInvoiceFile,
      ownerPayment:ownerPayment,setOwnerPayment:setOwnerPayment,
      dealerPayment:dealerPayment,setDealerPayment:setDealerPayment,
      invoiceInputValue:invoiceInputValue,setInvoiceInputValue:setInvoiceInputValue,
      invoiceManuallyEdited:invoiceManuallyEdited,setInvoiceManuallyEdited:setInvoiceManuallyEdited,
      sellCurrency:sellCurrency,setSellCurrency:setSellCurrency,
      sellExchangeRate:sellExchangeRate,setSellExchangeRate:setSellExchangeRate,
      invoiceMarkupWon:invoiceMarkupWon,purchaseDate:purchaseDate,setPurchaseDate:setPurchaseDate,buyRegion:buyRegion,setBuyRegion:setBuyRegion,
      initStatus:initStatus,setInitStatus:setInitStatus,
      cancelRequestedAt:cancelRequestedAt,setCancelRequestedAt:setCancelRequestedAt,
      cancelCompletedAt:cancelCompletedAt,setCancelCompletedAt:setCancelCompletedAt,
      autoOwnerSeal:autoOwnerSeal,setAutoOwnerSeal:setAutoOwnerSeal,
      // Phase B Wave 2.3: 소유자 매도 광고 동의
      ownerConsentGiven:ownerConsentGiven,setOwnerConsentGiven:setOwnerConsentGiven,
      ownerConsentDate:ownerConsentDate,setOwnerConsentDate:setOwnerConsentDate,
      ownerConsentMethod:ownerConsentMethod,setOwnerConsentMethod:setOwnerConsentMethod,
      ownerConsentFile:ownerConsentFile,setOwnerConsentFile:setOwnerConsentFile
    };
    return <CarRegisterForm f={f}/>;
  };

  // ═══ 미리보기 (공통) ═══
  var renderPreview=function(){return(<>
    <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:'12px 12px 0 0',padding:'10px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
      <div style={{display:'flex',gap:8,alignItems:'center'}}><b>📄 미리보기</b>{carNo&&<span style={{background:'#eff6ff',padding:'3px 10px',borderRadius:12,fontSize:11,fontWeight:600,color:'#2563eb'}}>🚗 {carNo}</span>}</div>
      <div style={{display:'flex',gap:3}}>
        {(function(){var _pl=[{k:'malso',l:'말소신청서'},{k:'contract',l:'매매계약서'},{k:'nonbiz',l:'비사업용'},{k:'pumui',l:'품의서'}];var _allowPumui=(selCompany&&selCompany.id===1);if(!_allowPumui)_pl=_pl.filter(function(t){return t.k!=='pumui'});return _pl.map(function(t){return(<button key={t.k} className={'btn btn-sm '+(pDoc===t.k?'btn-blue':'btn-outline')} onClick={function(){setPD(t.k)}}>{t.l}</button>)})})()}
        <button className="btn btn-sm btn-outline" onClick={printDoc} disabled={printing||saving} style={{cursor:(printing||saving)?'wait':'pointer'}}>{printing?'처리 중...':'🖨️ 등록하고 출력'}</button>
      </div>
    </div>
    <div style={{flex:1,background:'#e8e8e8',borderRadius:'0 0 12px 12px',overflow:'auto',padding:20,display:'flex',justifyContent:'center'}}>
      <div id="preview-area" style={{background:'#fff',width:700,minHeight:960,padding:'40px 44px',boxShadow:'0 2px 16px rgba(0,0,0,0.12)'}}>
        {pDoc==='malso'&&<MalsoPreview cn={carNo} vi={vin} ct={carType} u2={usage2} ow={owner} oa={ownerAddr} oi={ownerId} oib={ownerIdBack} ml={mileage} yy={yyyy} mo={mm} dy={dd}/>}
        {pDoc==='contract'&&<ContractPreview cn={carNo} vi={vin} ct={carType} ow={owner} oa={ownerAddr} oi={ownerId} oib={ownerIdBack} bp={((parseInt(ownerPayment)||0)+(parseInt(dealerPayment)||0))*10000} cp={(parseInt(contractPrice)||0)*10000} bl={(parseInt(balance)||0)*10000} bu={selCompany?{name:selCompany.nameKr||selCompany.name,bizNo:selCompany.bizNo,addr:selCompany.addr}:null} companyId={selCompany?selCompany.id:(user&&user.companyId)} autoOwnerSeal={autoOwnerSeal}/>}
        {pDoc==='nonbiz'&&<NonBizPreview cn={carNo} ct={carType} ow={owner} oi={ownerId} oib={ownerIdBack}/>}
        {pDoc==='pumui'&&<PumuiPreview cn={carNo} vi={vin} ct={carType} u2={usage2} ow={owner} oa={ownerAddr} oi={ownerId} oib={ownerIdBack} rd={regDate} ml={mileage} bp={((parseInt(ownerPayment)||0)+(parseInt(dealerPayment)||0))*10000} ocrFuel={ocrFuel} ocrDisp={ocrDisp}/>}
      </div>
    </div>
  </>)};

  var emptyPreview=<div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',background:'#f8fafc',borderRadius:12,border:'1px dashed #d0d5dd'}}><div style={{textAlign:'center',color:'#94a3b8'}}><div style={{fontSize:48,opacity:0.4}}>📄</div><div style={{fontSize:15,fontWeight:600,color:'#64748b',marginTop:8}}>{mode==='manual'?'왼쪽에서 정보를 입력하세요':'OCR 인식 후 미리보기'}</div></div></div>;

  // ═══ 렌더 ═══
  return(<div style={{height:'calc(100vh - 120px)',display:'flex',flexDirection:'column'}}>
    {/* 모드 선택 탭 */}
    <div style={{display:'flex',gap:4,marginBottom:12}}>
      {[{k:'ocr',l:'📷 OCR 등록',c:'#2563eb'},{k:'manual',l:'✏️ 수기 입력',c:'#059669'},{k:'batch-img',l:'📸 일괄 등록(이미지)',c:'#7c3aed'},{k:'batch-csv',l:'📦 엑셀 일괄등록',c:'#d97706'}].map(function(m){
        var active=mode===m.k;
        return(<button key={m.k} onClick={function(){setMode(m.k);if(m.k!=='batch-img'){rst();}setImgZoom(1);setImgPos({x:0,y:0})}} style={{padding:'8px 16px',borderRadius:8,fontSize:13,fontWeight:700,border:'2px solid '+(active?m.c:'#e2e8f0'),background:active?m.c:'#fff',color:active?'#fff':m.c,cursor:'pointer',transition:'all .15s'}}>{m.l}</button>);
      })}
    </div>

    <div style={{flex:1,display:'flex',gap:16,overflow:'hidden'}}>
      {/* ═══ OCR 모드 ═══ */}
      {mode==='ocr'&&<CarRegisterOCR files={files} setFiles={setFiles} dragOver={dragOver} setDO={setDO} ocrLoading={ocrLoading} ocrDone={ocrDone} doOcr={doOcr} rst={rst} zoomImg={zoomImg} renderForm={renderForm} renderPreview={renderPreview} emptyPreview={emptyPreview} saving={saving} reg={reg} initStatus={initStatus}/>}

      {/* ═══ 수기 입력 모드 ═══ */}
      {mode==='manual'&&<CarRegisterManual renderForm={renderForm} renderPreview={renderPreview} emptyPreview={emptyPreview} saving={saving} reg={reg} carNo={carNo} vin={vin} owner={owner}/>}

      {/* ═══ 일괄 모드 (이미지 + 엑셀) ═══ */}
      {(mode==='batch-img'||mode==='batch-csv')&&<CarRegisterBulk mode={mode}
        batchImages={batchImages} batchIdx={batchIdx} batchStatus={batchStatus}
        batchOcrLoading={batchOcrLoading} batchOcrResults={batchOcrResults}
        batchOcrDoneCount={batchOcrDoneCount} batchDoneCount={batchDoneCount}
        setBatchImages={setBatchImages} setBatchStatus={setBatchStatus}
        setBatchOcrResults={setBatchOcrResults} setBatchIdx={setBatchIdx}
        setBatchOcrDoneCount={setBatchOcrDoneCount} rst={rst}
        onBatchImgSelect={onBatchImgSelect} batchGoTo={batchGoTo}
        batchRegAndNext={batchRegAndNext} batchSkip={batchSkip}
        dragOver={dragOver} setDO={setDO}
        renderForm={renderForm} renderPreview={renderPreview} emptyPreview={emptyPreview}
        ocrDone={ocrDone} saving={saving} reg={reg} zoomImg={zoomImg}
        xlStep={xlStep} setXlStep={setXlStep} xlLoading={xlLoading} setXlLoading={setXlLoading}
        xlProgress={xlProgress} setXlProgress={setXlProgress}
        xlAnalysis={xlAnalysis} setXlAnalysis={setXlAnalysis}
        xlMapping={xlMapping} setXlMapping={setXlMapping}
        xlResults={xlResults} setXlResults={setXlResults}
        xlDetailOpen={xlDetailOpen} setXlDetailOpen={setXlDetailOpen}
        showToast={showToast}
        myCompanies={myCompanies} selCompany={selCompany} setSelCompany={setSelCompany} canSelectCompany={canSelectCompany}
      />}
    </div>
    {regDoneModal&&<div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
      <div style={{background:'#fff',borderRadius:16,padding:24,width:360,boxShadow:'0 8px 32px rgba(0,0,0,0.2)'}}>
        <div style={{fontSize:18,fontWeight:800,color:'#111',marginBottom:16}}>차량 등록 완료</div>
        <div style={{background:'#f8f8f5',borderRadius:10,padding:14,marginBottom:16}}>
          <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}><span style={{fontSize:12,color:'#888'}}>차량번호</span><span style={{fontSize:14,fontWeight:700}}>{regDoneModal.carNo||'-'}</span></div>
          <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}><span style={{fontSize:12,color:'#888'}}>차종</span><span style={{fontSize:14,fontWeight:600}}>{regDoneModal.carType||'-'}</span></div>
          {regDoneModal.buyPrice>0&&<div style={{display:'flex',justifyContent:'space-between'}}><span style={{fontSize:12,color:'#888'}}>매입가</span><span style={{fontSize:14,fontWeight:700,color:'#D85A30'}}>{regDoneModal.buyPrice.toLocaleString()}만원</span></div>}
        </div>
        <div style={{fontSize:12,color:'#888',marginBottom:16}}>서류 4종이 자동 생성 중입니다.</div>
        <div style={{display:'flex',gap:8}}>
          <button onClick={regDoneModal.onClose} style={{flex:1,padding:'12px 0',borderRadius:10,border:'1px solid #ddd',background:'#fff',fontSize:14,fontWeight:600,cursor:'pointer',color:'#555'}}>확인</button>
          {regDoneModal.carId&&<button onClick={function(){setRegDoneModal(null);window.location.href='/main/car-list'}} style={{flex:1,padding:'12px 0',borderRadius:10,border:'none',background:'#1B3A5C',color:'#fff',fontSize:14,fontWeight:600,cursor:'pointer'}}>차량 목록 보기</button>}
        </div>
      </div>
    </div>}
    {modal&&<CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
  </div>);
}

export default CarRegisterPage;
